

export default function ElegantHeader() {
  return (
    <div className=" bg-white flex items-center justify-center p-8 ">
      <div className="max-w-6xl text-center">
        <h1 className="text-3xl md:text-5xl font-serif text-gray-900 mb-3">
          Once Upon a Time... A Night of Wax and Gold
        </h1>
        <p className="text-base md:text-sm text-gray-700 leading-relaxed font-light">
          This holiday season, a winter tale unfolds. As a Parisian pine tree forest awakens in Paris, festive icons emerge. Golden pine cones. Archibald the Cat. Each creation, touched by gold, is an invitation to let the imagination wander.
        </p>
      </div>
    </div>
  );
}